import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { EmployeeDetails } from "./employee-details.entity";

@Entity('employee_skill_matrix')
export class EmployeeSkillMatrix {

    @PrimaryGeneratedColumn("increment", { name: 'employee_skill_matrix_id' })
    employeeSkillMatrixId: number;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "machine_wise"
    })
    machineWise: string;

    @Column("boolean", {
        nullable: true,
        name: "needle_type"
    })
    needleType: boolean;
  @Column("boolean" , {
        nullable : true,
        name: "needle_bar_adjustment"
    })
    needleBarAdjustment: boolean;
    @Column("boolean", {
        nullable: true,
        name: "hook_set_looper_timings"
    })
    hookSetLooperTimings: boolean;

    @Column("boolean", {
        nullable: true,
        name: "stitching_adjustment"
    })
    stitchingAdjustment: boolean;
  @Column("boolean" , {
        nullable : true,
        name: "u_B_triming"
    })
    uBTriming: boolean;
    @Column("boolean", {
        nullable: true,
        name: "feed_timing"
    })
    feedTiming: boolean;

    
    @Column("boolean", {
        nullable: true,
        name: "program_setting"
    })
    programSetting: boolean;
  @Column("boolean" , {
        nullable : true,
        name: "lubrication_sytsem"
    })
    lubricationSystem: boolean;
    @Column("boolean", {
        nullable: true,
        name: "puller_assembly"
    })
    pullerAssembly: boolean;

    @Column("boolean", {
        nullable: true,
        name: "split_bar_mechanism"
    })
    splitBarMechanism: boolean;
  @Column("boolean" , {
        nullable : true,
        name: "gauge_set_replacement"
    })
    gaugeSetReplacement: boolean;
    @Column("boolean", {
        nullable: true,
        name: "looper_thread_take_up_cam_timing"
    })
    looperThreadTakeUpCamTiming: boolean;
    @Column("boolean", {
        nullable: true,
        name: "needle_gaurd_adjustment"
    })
    needleGaurdAdjustment: boolean;
  @Column("boolean" , {
        nullable : true,
        name: "folder_attachement_setting_basic"
    })
    folderAttachementSettingBasic: boolean;
    @Column("boolean", {
        nullable: true,
        name: "snap_die_fixing"
    })
    snapDieFixing: boolean;

    @Column("boolean", {
        nullable: true,
        name: "safety_requirements"
    })
    safetyRequirements: boolean;
  @Column("boolean" , {
        nullable : true,
        name: "preventive_maintenance"
    })
    preventiveMaintenance: boolean;
    @Column("varchar", {
        nullable: true,
        length:10,
        name: "of_skill_aquired"
    })
    OfSkillAquired: number;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column({ name: "employee_id" })
    employeeId: number;
}
